import { FC } from "react";
import { Check } from "lucide-react";

interface MembershipListSectionProps {
  title: string;
  items: string[];
  bgClass: string;
  textClass: string;
}

const MembershipListSection: FC<MembershipListSectionProps> = ({
  title,
  items,
  bgClass,
  textClass,
}) => {
  return (
    <div
      className={`${bgClass} flex w-full flex-col gap-8 rounded-[26px] p-6 md:p-[60px]`}
    >
      <h4 className={`text-[20px] font-medium md:text-[24px] ${textClass}`}>
        {title}
      </h4>
      <div className={`flex w-full flex-col gap-4 ${textClass}`}>
        {items.map((item, i) => (
          <div key={i} className="flex items-center gap-3">
            <Check size={16} className="shrink-0" />
            <span className="text-[16px] leading-[1.5]">{item}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MembershipListSection;
